import React, { useEffect, useState } from "react";

import { useQuery } from "@apollo/client";
import { Select } from "antd";

import { QUERY_DISTRICTS } from "../../../../operations/queries/districts";

const DistrictsSelector = ({
  reportDefRef,
  disabled,
  mode,
  reportDefChanged,
  setReportDefChanged,
}) => {
  if (!reportDefRef?.current) {return <></>} //Wait until we have a valid reportDefRef
  // if (!reportDefRef?.current?.reportParameters?.selectedDistrictIds) {return <></>} //Wait until we have a valid reportDefRef

  const defSelectedDistrictIds = reportDefRef?.current?.reportParameters?.selectedDistrictIds ? reportDefRef.current.reportParameters.selectedDistrictIds : []
  const [selectedDistrictIds, setSelectedDistrictIds] = useState([])

  //Get user's allowed districts
  const { data, loading, error } = useQuery(QUERY_DISTRICTS, {
    fetchPolicy: 'cache-first',
  });
    
  if (error) {
    return (
      <Alert
        message="Failed loading districts"
        description={error.message}
        type="error"
        showIcon
      />
    );
  }

  //Load select options from districts
  const options = (data?.districts.map((district) => ({
    label: district.name,
    value: district.id,
  })) ?? []).sort((a, b) => a.label.localeCompare(b.label));

  //Remove any selectedDistrictIds stored in reportDefRef that are not in the user's allowed districts(e.g. report def saved by someone with permission to more districts that user)
  useEffect(() => {
    if (loading || !data) return;
  
    const validOptionIds = new Set(options.map((option) => option.value));
    const validValues = defSelectedDistrictIds.filter(id => validOptionIds.has(id));
  
    // Sort both arrays before comparing (order-agnostic)
    const sortedValidValues = [...validValues].sort();
    const sortedSelected = [...selectedDistrictIds].sort();
  
    const arraysMatch = sortedValidValues.length === sortedSelected.length &&
      sortedValidValues.every((val, i) => val === sortedSelected[i]);
  
    if (!arraysMatch) {
      setSelectedDistrictIds(validValues);
      const updatedDefRef = {
        ...reportDefRef.current,
        reportParameters: { selectedDistrictIds: validValues },
      };
      reportDefRef.current = updatedDefRef;
    }
  }, [loading, data, defSelectedDistrictIds]);

  const handleDistrictIdsChange = (value) => {
    setSelectedDistrictIds(value);
    let newReportParameters = {selectedDistrictIds: value}
    let updatedDefRef = {...reportDefRef.current}
    updatedDefRef.reportParameters = newReportParameters
    reportDefRef.current = updatedDefRef
    setReportDefChanged(!reportDefChanged)

  };

  return (
    <Select
      disabled={disabled}
      mode={mode}
      allowClear
      style={{ width: '100%' }}
      placeholder={loading ? 'Loading...' : 'Select district(s) for the report'}
      value={selectedDistrictIds}
      onChange={handleDistrictIdsChange}
      options={options}
    />
  )
}

export default DistrictsSelector;
